import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  HostListener,
  ElementRef, ViewChildren, QueryList
} from '@angular/core';
import {ContextMenuOptions} from '../../../../../Models/contextMenu';
import {Router} from '@angular/router';


@Component({
  selector: 'app-graph-detail',
  templateUrl: './graph-detail.component.html',
  styleUrls: ['./graph-detail.component.css']
})

export class GraphDetailComponent implements OnInit, AfterViewInit{

  @Input() graphContext;
  @Input() businessProcessId;

  contextMenuOptions: ContextMenuOptions;
  currentNode;
  filterText:string;
  filterTextCount: number;
  graphWidth:number;
  isDisplayContextMenu:boolean;
  rightClickMenuPositionX:number;
  rightClickMenuPositionY:number;

  @ViewChildren('gNode') gNodes: QueryList<ElementRef>;

  constructor( private router: Router) {
  }

  ngOnInit(): void {
    this.contextMenuOptions = new ContextMenuOptions();
    this.contextMenuOptions.items = [
      {
        id:'changeState',
        name: 'Modificar informações do estado',
        icon: 'fa fa-pen',
        hasHr: false,
        callback:()=>{
          if (this.currentNode.stateInfo) {
            this.router.navigate(['/state', this.businessProcessId, this.currentNode.stateInfo.stateId]);
          }
        }
      },
      {
        id:'openStateFlow',
        name: 'Abrir fluxo do estado',
        icon: 'fa fa-cogs',
        hasHr: false,
        callback:()=>{
          if (this.currentNode.stateInfo && this.currentNode.stateInfo.stateFlowDesignerLink) {
            window.open(this.currentNode.stateInfo.stateFlowDesignerLink, '_parent');
          } else {
            alert("Não existe fluxo associado para este estado");
          }
        }
      },
      {
        id:'openStateFlowDebugger',
        name: 'Depurar fluxo do estado',
        icon: 'fa fa-bug',
        hasHr: false,
        callback:()=>{
          if (this.currentNode.stateInfo && this.currentNode.stateInfo.stateFlowDesignerLink) {
            window.open(this.currentNode.stateInfo.stateFlowDebuggerLink, '_parent');
          }else {
            alert("Não existe fluxo associado para este estado");
          }
        }
      },
      {
        id:'openLayout',
        name: 'Alterar layout da tela',
        icon:'fa fa-desktop',
        hasHr: true,
        callback:()=>{
          if (this.currentNode.stateInfo && this.currentNode.stateInfo.pageLayoutEditorLink) {
            window.open(this.currentNode.stateInfo.pageLayoutEditorLink, '_blank');
          } else {
            alert("Não existe layout de tela associado para este estado")
          }
        }
      },
      {
        id:'openPageFlow',
        name: 'Abrir fluxo de tela',
        icon:'',
        hasHr: false,
        callback:()=>{
          if (this.currentNode.stateInfo && this.currentNode.stateInfo.pageFlowDesignerLink) {
            window.open(this.currentNode.stateInfo.pageFlowDesignerLink, '_blank');
          } else {
            alert("Não existe fluxo de tela associado para este estado")
          }
        }
      },
      {
        id:'openPageFlowDebugger',
        name: 'Depurar fluxo de tela',
        icon:'',
        hasHr: false,
        callback:()=>{
          if (this.currentNode.stateInfo && this.currentNode.stateInfo.pageFlowDesignerLink) {
            window.open(this.currentNode.stateInfo.pageFlowDebuggerLink, '_blank');
          } else {
            alert("Não existe fluxo de tela associado para este estado")
          }
        }
      },
    ];
  }

  ngAfterViewInit(): void {
    this.graphWidth = parseInt(this.graphContext.svgWidth, 10);
  }

  displayContextMenu(event, node) {
    event.preventDefault();
    this.isDisplayContextMenu = true;

    this.rightClickMenuPositionX = event.clientX;
    this.rightClickMenuPositionY = event.clientY - 180;
    this.currentNode = node;
  }

  @HostListener('document:click')
  documentClick(): void {
    this.isDisplayContextMenu = false;
    this.currentNode = undefined;
  }

  getRightClickMenuStyle() {
    return {
      position: 'fixed',
      left: `${this.rightClickMenuPositionX}px`,
      top: `${this.rightClickMenuPositionY}px`
    }
  }

  showGraph(){
    return this.graphContext && this.graphContext.nodes && this.graphContext.nodes.length > 0;
  }

  resizeGraph(level){
    let canvas = $('div.graphCanvas');
    let canvasWidth = canvas.innerWidth() || 1;
    let sizeRatio = 1;

    if (level == '0') {
      sizeRatio = canvasWidth / this.graphWidth;

      if (sizeRatio > 1) {
        sizeRatio = 1;
      }
    } else {
      level = parseInt(level, 10) / 100;
      sizeRatio = level || 1;
    }

    let newSize = this.graphWidth * sizeRatio;
    this.graphContext.svgWidth = newSize + "pt";
  }

  performHighlight() {
    this.reset();
    if (!this.filterText) return;
    let pattern = new RegExp(this.filterText, 'im');
    this.filterTextCount = 0;
    this.gNodes.forEach(n => {
      if (pattern.test(n.nativeElement.textContent)) {
        n.nativeElement.classList.add('highlighted');
        this.filterTextCount++;
      } else {
        n.nativeElement.classList.add('dimmed');
      }
    });
  }

  reset(){
    this.filterTextCount = undefined;
    this.gNodes.forEach(n => {
        n.nativeElement.classList.remove('highlighted');
        n.nativeElement.classList.remove('dimmed');
    });
  }
}


